var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ArticleProgressBar,{attrs:{"current-status":_setup.currentArticleImportStatus,"title":_vm.$t('salesChannelManagementApp.journal.articleListBuilding').toString(),"info":_vm.$t('salesChannelManagementApp.journal.articleListBuildingInfo').toString()}})
}
var staticRenderFns = []

export { render, staticRenderFns }